<template>
  <div>
    <div class="titleTop">
      <div class="container">
        <div class="logo">
          <router-link to="/">XCL</router-link>
        </div>

        <!-- 仅在小于 1024px 尺寸下显示汉堡菜单 -->
        <div class="hamburger" :class="{ 'is-active': isMobileMenuOpen }" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="nav-wrap" :class="{ 'mobile-show': isMobileMenuOpen }">
          <ul class="nav-links">
            <li
              v-for="(item, index) in menuItems"
              :key="index"
              @mouseenter="enterMenu(index)"
              @mouseleave="delayLeaveMenu"
              class="xcl-menu-item"
              :class="{ activeNav: activeIndex === index }"
            >
              <div class="menu-trigger" @click="toggleSubMenu(index)">
                <span class="el-dropdown-link">
                  {{ item.name }}
                </span>
                <i
                  class="el-icon-arrow-down el-icon--right"
                  style="font-weight: bold;position: relative; top: 2px; margin-left: 4px;"
                  :style="{ transform: activeIndex === index && windowWidth < 1024 ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }"
                ></i>
              </div>

              <div
                v-show="activeIndex === index"
                class="xcl-dropdown-panel"
                @mouseenter="clearLeaveTimer"
                @mouseleave="delayLeaveMenu"
              >
                <div class="xcl-panel-inner">
                  <div class="xcl-panel-left" :class="item.layout">
                    <h2 class="panel-title">{{ item.panelTitle }}</h2>

                    <div v-if="item.layout === '2col'" class="link-grid">
                      <div
                        v-for="(col, colIndex) in item.linkColumns"
                        :key="colIndex"
                        class="link-column"
                      >
                        <router-link
                          v-for="(link, lix) in col"
                          :key="lix"
                          class="link-item"
                          :to="link.url"
                          @click="closeAllMenus"
                        >
                          <span class="link-icon">{{ link.icon }}</span>
                          
                          <div class="link-content">
                            <h3 class="link-title">{{ link.title }}</h3>
                            <p v-if="link.desc" class="link-desc">{{ link.desc }}</p>
                          </div>
                        </router-link>
                      </div>
                    </div>

                    <div
                      v-else-if="item.layout === '4col'"
                      class="four-col-grid"
                    >
                      <div
                        v-for="(col, colIndex) in item.linkColumns"
                        :key="colIndex"
                        class="four-col-column"
                      >
                        <router-link
                          v-for="(link, lix) in col"
                          :key="lix"
                          class="four-col-item"
                          :to="link.url"
                          @click="closeAllMenus"
                        >
                          <span class="link-icon">{{ link.icon }}</span>
                          <div class="link-content">
                            <h3 class="link-title">
                              {{ link.title }}
                              <span v-if="link.badge" class="badge">{{ link.badge }}</span>
                            </h3>
                            <p v-if="link.desc" class="link-desc">{{ link.desc }}</p>
                            <router-link
                              v-if="link.btn"
                              class="link-btn"
                              :to="link.url"
                              @click="closeAllMenus"
                            >
                              {{ link.btn }} <i class="el-icon-right"></i>
                            </router-link>
                          </div>
                        </router-link>
                      </div>
                    </div>

                    <div
                      v-if="item.bottomLinks"
                      class="panel-bottom-links"
                    >
                      <router-link
                        v-for="(bl, bi) in item.bottomLinks"
                        :key="bi"
                        class="bottom-link"
                        :class="bl.isFullWidth ? 'fullWidth' : ''"
                        :to="bl.url"
                        @click="closeAllMenus"
                      >
                        <span v-if="bl.isFullWidth">
                          <span class="btn-normal-text">{{
                            bl.text.split('Talk to Our Team')[0]
                          }}</span>
                          <span class="btn-highlight-text"
                            >Talk to Our Team <i class="el-icon-right"></i
                          ></span>
                        </span>
                        <span v-else>{{ bl.text }}<i class="el-icon-right"></i></span>
                      </router-link>
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.bottomBanner"
                  class="company-banner"
                >
                  <span>{{ item.bottomBanner.text }}</span>
                  <router-link
                    class="banner-btn"
                    :to="item.bottomBanner.url"
                    @click="closeAllMenus"
                  >
                    {{ item.bottomBanner.btn }}
                    <i class="el-icon-right"></i>
                  </router-link>
                </div>
              </div>
            </li>

            <li class="xcl-menu-item">
              <router-link
                to="/contact"
                style="text-decoration: none"
                class="el-dropdown-link standalone-link"
                @click="closeAllMenus"
              >
                Contact Us
              </router-link>
            </li>
            <li class="xcl-menu-item mobile-only-quote">
              <router-link to="/quote" class="get-quote" @click="closeAllMenus">
                <span>Get Instant Quote <i class="el-icon-right"></i></span>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="extra-links">
          <router-link to="/quote" class="get-quote">
            <span>Get Instant Quote <i class="el-icon-right"></i></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onUnmounted, onMounted } from 'vue'

export default {
  name: 'Navbar',
  setup() {
    const activeIndex = ref(-1)
    const isMobileMenuOpen = ref(false)
    const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1200)
    let leaveTimer = null
    let lastEnterTime = 0 

    // 以 1024px 作为手机/桌面的核心逻辑分界点
    const handleResize = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value >= 1024 && isMobileMenuOpen.value) {
        isMobileMenuOpen.value = false
        activeIndex.value = -1
      }
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    const handleImageError = (e) => {
      e.target.src =
        'https://via.placeholder.com/520x260/eeeeee/66666?text=Image+Error'
    }

    const menuItems = ref([
      {
        name: 'Capabilities',
        panelTitle: 'Capabilities',
        layout: '2col',
        linkColumns: [
          [
            { title: 'CNC Machining', desc: 'Tight tolerances and finishing capabilities, manufactured in one day.', url: '/cnc-machining' },
            { title: 'Sheet Metal', desc: 'Experience the versatility & cost efficiency with flexible application options.', url: '/sheet-metal' },
            { title: '3D Printing', desc: 'FDM, SLS, SLA, PolyJet, MJF technologies.', url: '/3d-printing' },
          ],
          [
            { title: 'Die Casting', desc: 'Create high quality custom mechanicals with precision and accuracy.', url: '/die-casting' },
            { title: 'Compression Molding', desc: 'Experience lower tooling costs with high-quality durable parts.', url: '/compression-molding' },
          ],
        ],
      },
      {
        name: 'Industries',
        panelTitle: 'Industries',
        layout: '4col',
        linkColumns: [
          [
            { title: 'Aerospace', url: '/industries/aerospace' },
            { title: 'Automotive', url: '/industries/automotive' },
          ],
          [
            { title: 'Semiconductor', url: '/industries/semiconductor' },
            { title: 'Medical', url: '/industries/medical' },
          ],
          [
            { title: 'Consumer products', url: '/industries/consumer-products' },
            { title: 'Robotics', url: '/industries/robotics' },
          ],
          [
            { title: 'Electronics', url: '/industries/electronics' },
            { title: 'New Energy', url: '/industries/new-energy' },
          ],
        ],
        bottomBanner: {
          text: 'Ready to get started?',
          btn: 'Get an instant quote',
          url: '/quote',
        },
      },
      {
        name: 'About Us',
        panelTitle: 'About Us',
        layout: '2col',
        linkColumns: [
          [{ title: 'About Company', url: '/about-company' }],
          [{ title: 'Quality Management', url: '/quality-management' }],
          [{ title: 'FAQ', url: '/faq' }],
        ],
        bottomBanner: {
          text: 'Ready to get started?',
          btn: 'Get an instant quote',
          url: '/quote',
        },
      },
    ])

    const enterMenu = (index) => {
      if (windowWidth.value >= 1024) {
        clearLeaveTimer()
        if (activeIndex.value !== index) {
          lastEnterTime = Date.now()
          activeIndex.value = index
        }
      }
    }

    const delayLeaveMenu = () => {
      if (windowWidth.value >= 1024) {
        leaveTimer = setTimeout(() => {
          activeIndex.value = -1
        }, 150)
      }
    }

    const clearLeaveTimer = () => {
      if (leaveTimer) clearTimeout(leaveTimer)
    }

    const toggleSubMenu = (index) => {
      if (windowWidth.value >= 1024) {
        if (Date.now() - lastEnterTime < 300) {
          return 
        }
      }
      
      if (activeIndex.value === index) {
        activeIndex.value = -1 
      } else {
        activeIndex.value = index 
      }
    }

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value
      if (!isMobileMenuOpen.value) {
        activeIndex.value = -1
      }
    }

    const closeAllMenus = () => {
      isMobileMenuOpen.value = false
      activeIndex.value = -1
    }

    onUnmounted(() => {
      clearLeaveTimer()
      window.removeEventListener('resize', handleResize)
    })

    return {
      activeIndex,
      isMobileMenuOpen,
      windowWidth,
      menuItems,
      enterMenu,
      delayLeaveMenu,
      clearLeaveTimer,
      handleImageError,
      toggleMobileMenu,
      toggleSubMenu, 
      closeAllMenus,
    }
  },
}
</script>

<style>
/* ========================================================
   基础与全局重置
   ======================================================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
  -webkit-tap-highlight-color: transparent;
}

.nav-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.titleTop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 999;
  border-bottom: 1px solid #e5e7eb;
  height: 65px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 100%;
}

.nav-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
}

.menu-trigger,
.el-dropdown-link {
  cursor: pointer;
  color: #595959;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  outline: none;
  background: transparent;
}

.extra-links {
  display: flex;
  align-items: center;
  gap: 20px;
}

.get-quote {
  background: #16bc9c;
  color: #fff;
  padding: 13px 28px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  white-space: nowrap;
}

.get-quote span {
  position: relative;
  z-index: 2;
}

.get-quote::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #027062;
  transition: all 0.4s;
  z-index: 0;
}

.get-quote:hover::before {
  left: 0;
}

.get-quote .el-icon-right {
  font-weight: bold;
  margin-left: 4px;
}

/* 仅桌面端支持 Hover */
@media (hover: hover) {
  .nav-links li:hover .el-dropdown-link,
  .nav-links li:hover .menu-trigger,
  .xcl-menu-item:hover .el-dropdown-link,
  .xcl-menu-item:hover .menu-trigger,
  .xcl-menu-item:hover .el-icon-arrow-down {
    color: #16bc9c !important;
  }
}

.xcl-dropdown-panel {
  position: fixed;
  top: 65px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 900px; 
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  z-index: 99999 !important;
  border-radius: 0 0 8px 8px;
  overflow-y: auto;
  max-height: 80vh;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.xcl-panel-inner {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  align-items: flex-start;
  padding: 32px 20px;
}

.xcl-panel-left {
  flex: 1;
}

.panel-title {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 20px;
}

.link-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 60px;
  margin-bottom: 8px;
}

.link-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
}

.link-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-decoration: none;
  color: inherit;
}

.link-icon {
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.link-item:hover .link-icon,
.link-item:hover .link-title {
  color: #26c2a0;
}

.four-col-item:hover .link-icon,
.four-col-item:hover .link-title {
  color: #16bc9c !important;
}

.link-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 2px;
}

.el-icon-right {
  font-weight: 700;
}

.link-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  font-weight: 500;
}

.panel-bottom-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bottom-link {
  font-size: 16px;
  font-weight: 600;
  color: #26c2a0;
  text-decoration: none;
  display: inline-flex;
  cursor: pointer;
}

.bottom-link:hover {
  color: #1f9e82;
}

.xcl-menu-item.activeNav .el-dropdown-link,
.xcl-menu-item.activeNav .menu-trigger,
.xcl-menu-item.activeNav .el-icon-arrow-down {
  color: #16bc9c !important;
}

.fullWidth {
  width: 100%;
  padding: 16px;
  background: #f0f4f7;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 16px;
  border: 1px solid #e5e7eb;
  margin-top: 20px;
}

.btn-normal-text {
  color: #333;
  font-weight: 500;
}

.btn-highlight-text {
  color: #16bc9c;
  font-weight: 600;
}

.btn-highlight-text:hover {
  color: #1f9e82;
}

.four-col-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 8px;
}

.four-col-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  cursor: pointer;
}

.four-col-item {
  display: flex;
  gap: 10px;
  text-decoration: none;
  color: inherit;
  flex-direction: row;
  align-items: baseline;
}

.link-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
}

.badge {
  background: #e6f7f3;
  color: #0e957b;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 12px;
  margin-left: 6px;
}

.link-btn {
  font-size: 13px;
  color: #16bc9c;
  text-decoration: none;
  margin-top: auto;
  display: inline-block;
  font-weight: 600;
}

.link-btn:hover {
  color: #0e957b;
}

.company-banner {
  width: 100%;
  padding: 20px;
  background: #f0f4f7;
  text-align: center;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #e5e7eb;
}

.company-banner span {
  font-size: 18px;
  font-weight: bold;
  margin-right: 16px;
  color: #111827;
}

.banner-btn {
  color: #16bc9c;
  font-weight: bold;
  text-decoration: none;
}

.banner-btn:hover {
  color: #0e957b;
  cursor: pointer;
}

/* ========================================================
   1. lg & xl 桌面端 (>= 1200px)
   ======================================================== */
@media (min-width: 1200px) {
  .logo a {
    font-size: 28px;
    color: #16bc9c;
    font-weight: 600;
    text-decoration: none;
    position: relative;
    left: 40px;
  }
  .nav-links {
    display: flex;
    gap: 40px;
    align-items: center;
    position: relative;
    right: 142px;
  }
  .hamburger { display: none; }
  .mobile-only-quote { display: none !important; }
}

/* ========================================================
   2. md: 中等桌面屏幕 (>= 1024px && < 1200px) 
   ======================================================== */
@media (min-width: 1024px) and (max-width: 1199px) {
  .logo a {
    font-size: 24px;
    color: #16bc9c;
    font-weight: 600;
    text-decoration: none;
    /* 与大屏幕对齐一致，改为 40px 偏移 */
    position: relative;
    left: 40px; 
  }
  .nav-links {
    display: flex;
    gap: 20px; 
    align-items: center;
    position: relative;
    right: 40px;
  }
  .hamburger { display: none; }
  .mobile-only-quote { display: none !important; }

  .four-col-grid { grid-template-columns: repeat(2, 1fr); }
  .xcl-dropdown-panel { max-width: 800px; }
}

/* ========================================================
   3. sm & xs 移动端统一样式 (< 1024px) 
   完全启用汉堡菜单，面板强制单列
   ======================================================== */
@media (max-width: 1023px) {
  .logo a {
    font-size: 24px;
    color: #16bc9c;
    font-weight: 600;
    text-decoration: none;
    position: static;
  }

  .extra-links { display: none; }

  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 18px;
    cursor: pointer;
    z-index: 1000;
  }
  .hamburger span {
    display: block;
    height: 2px;
    width: 100%;
    background-color: #333;
    transition: all 0.3s ease;
  }
  .hamburger.is-active span:nth-child(1) { transform: translateY(8px) rotate(45deg); }
  .hamburger.is-active span:nth-child(2) { opacity: 0; }
  .hamburger.is-active span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }

  .nav-wrap {
    position: absolute; 
    top: 65px;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    display: none;
    padding: 10px 20px 25px 20px; 
    max-height: calc(100vh - 65px);
    max-height: calc(100dvh - 65px); 
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; 
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  }
  
  .nav-wrap.mobile-show { display: block; }
  
  .nav-links {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    position: static;
  }
  
  .nav-links li {
    border-bottom: 1px solid #f3f4f6;
    width: 100%;
    display: flex !important;
    flex-direction: column !important; 
  }

  .menu-trigger,
  .standalone-link {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    justify-content: space-between !important;
    padding: 15px 0 !important;
    min-height: 54px !important;
    visibility: visible !important;
    cursor: pointer;
  }

  .el-dropdown-link { font-size: 16px; }

  /* 移动端菜单底部的 Get Quote 按钮布局 */
  .mobile-only-quote {
    padding: 15px 0 0 0 !important;
    border-bottom: none !important;
    display: block !important;
  }
  .mobile-only-quote .get-quote {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .xcl-dropdown-panel {
    position: static !important;
    width: 100% !important;
    box-shadow: none !important;
    max-height: none !important;
    border-radius: 0 !important;
    background: #fafafa !important;
    margin-top: 10px !important; 
    margin-bottom: 10px !important; 
    border-left: 3px solid #16bc9c !important;
  }
  
  .xcl-panel-inner {
    padding: 15px;
    gap: 20px;
    flex-direction: column;
  }
  .panel-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .company-banner {
    width: 100%;
    margin: 15px 0 0 0;
    border-radius: 0;
    padding: 15px;
  }
  .company-banner span {
    font-size: 14px;
    display: block;
    margin-bottom: 8px;
    margin-right: 0;
  }
  .fullWidth {
    position: static;
    margin-top: 15px;
  }

  /* 强制小于 1024px 时下拉面板内的布局一律单列 */
  .link-grid, .four-col-grid {
    grid-template-columns: 1fr !important;
    gap: 15px !important;
    margin-bottom: 15px;
  }
  .four-col-column, .link-column {
    gap: 15px;
  }
  .link-title {
    font-size: 16px;
  }
}
</style>